import type { ReactNode } from 'react';
import { AlertIcon, CheckIcon } from '@/components/icons';
import { cn } from '@/lib/cn';

type NoticeProps = {
  tone?: 'info' | 'success';
  title?: string;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
};

/** Non-error inline message (e.g. "This challenge was updated", pass feedback on the landing card). */
export function Notice({ tone = 'info', title, children, action, className }: NoticeProps) {
  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-3 rounded-md px-4 py-3.5 text-sm leading-normal',
        tone === 'success' ? 'bg-success-soft text-success-ink' : 'bg-accent-soft text-accent-hover',
        className,
      )}
    >
      {tone === 'success' ? (
        <CheckIcon size={20} className="mt-px shrink-0 text-success" />
      ) : (
        <AlertIcon size={20} className="mt-px shrink-0" />
      )}
      <div className="flex min-w-0 flex-1 flex-col items-start gap-2">
        <div>
          {title && <strong className="font-semibold">{title} </strong>}
          {children}
        </div>
        {action}
      </div>
    </div>
  );
}
